document.addEventListener("DOMContentLoaded", function() {

	var $ = jQuery.noConflict();
	
	/* Phone / Numbers & + only Validation */
	$('input[type=tel],input[type=number],input[type=range],input[type=time]').on('input propertychange', function (e) {
		e.target.value = e.target.value.replace(/[a-zA-Z]/g,'');
	  	return false;
	});

	/* Name / Text only Validation */
	$('input[type=text]').on('input propertychange', function (e) {
		e.target.value = e.target.value.replace(/[0-9]/g,'');
	  	return false;
	});

});